import { ReactElement } from "react";

interface ReportActionsProps {
  hasFile: boolean;
  submitting: boolean;
  completed: boolean;
  onReset: () => void;
  onSubmit: () => void;
}

/** Footer actions for the upload panel. */
const ReportActions: React.FC<ReportActionsProps> = ({
  hasFile,
  submitting,
  completed,
  onReset,
  onSubmit,
}): ReactElement => {
  if (completed) {
    return (
      <div className="actions">
        <button type="button" className="primary" onClick={onReset}>
          Upload another report
        </button>
      </div>
    );
  }

  return (
    <div className="actions">
      {hasFile && (
        <span className="hint">
          The completed workbook downloads automatically.
        </span>
      )}
      <button
        type="button"
        className="ghost"
        disabled={!hasFile || submitting}
        onClick={onReset}
      >
        Cancel
      </button>
      {/* Enabled as soon as a file is picked — the backend decides whether the
          report is acceptable, not this form. */}
      <button
        type="button"
        className="primary"
        disabled={!hasFile || submitting}
        onClick={onSubmit}
      >
        {submitting ? "Filling client IPs…" : "Fill client IPs"}
      </button>
    </div>
  );
};

export default ReportActions;
